/* eslint-disable camelcase */
export const generateQueryString = (selectedFilters, includeOfferCategory = false) => {
  const filterKeys = Object.keys(selectedFilters);
  filterKeys.forEach(filter => {
    if (filter.indexOf('pageIndex') > -1 || filter.indexOf('pageSize') > -1) {
      const value = isNaN(parseInt(selectedFilters[filter], 10)) ? 0 : parseInt(selectedFilters[filter], 10);
      selectedFilters[filter] = value;
    }
  })


  const queryStringParts = [];
  const addedValues = new Set();

  const addToQueryString = (key, value) => {
    const keyValueString = `${key}-${value}`;
    if (!addedValues.has(keyValueString)) {
      queryStringParts.push(`${key}=${encodeURIComponent(value)}`);
      addedValues.add(keyValueString);
    }
  };

  Object.entries(selectedFilters)
    .filter(([key]) => key !== 'id' && key !== 'firstLoad')
    .sort(([key1], [key2]) => key1.localeCompare(key2))
    .forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value
          .filter((item) => typeof item === 'string' && (item !== 'PARTICULARES' && !item.includes('FUSION') || includeOfferCategory))
          .sort()
          .forEach((item) => {
            addToQueryString(key, item);
          });
      } else if (typeof value === 'string' && (value !== 'PARTICULARES' && !value.includes('FUSION') || includeOfferCategory)) {
        addToQueryString(key, value);
      } else if (typeof value === 'number') {
        addToQueryString(key, value);
      }
    });
  return queryStringParts.join('&');
};

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const obtenerURLEnv = () => {

  let entorno = process.env.NEXT_PUBLIC_ENV_NAME;
  if (entorno === 'qa') {
    return 'qa.catalogue.col.movistar.es';
  } else if (entorno === 'prod') {
    return 'catalogue.col.movistar.es';
  } else {
    return 'orion.dev.col.movistar.es';
  }
};

export const retornarFiltrosValidos = (objeto) => {
  const objetoFiltrado = {};

  const isOldPagination = objeto.pageIndex || objeto.pageSize;

  //Convert old pagination way in the new one
  if (isOldPagination) {
    objeto.pageSize = objeto.pageSize || 39;
    objeto.pageIndex = objeto.pageIndex || 0;
    objeto.resultLimit = objeto.pageSize;
    objeto.resultFrom = parseInt(objeto.pageSize) * parseInt(objeto.pageIndex);
    delete objeto.pageIndex;
    delete objeto.pageSize;
  }

  for (const clave in objeto) {
    if (objeto.hasOwnProperty(clave) && objeto[clave] !== "") {
      objetoFiltrado[clave] = objeto[clave];
    }
  }
  return objetoFiltrado;
}

export const getBreadcrumbCategoryTextById = (id, breadcrumbText) => {
  let textoEncontrado;

  if (breadcrumbText) {
    textoEncontrado = breadcrumbText;
  }

  if (textoEncontrado) {
    return textoEncontrado;
  } else {
    return capitalizeFirstLetter(id);
  }
}

export const getCategoryTextById = (id, categoryName) => {
  let textoEncontrado;

  if (categoryName) {
    textoEncontrado = categoryName;
  }

  if (textoEncontrado) {
    return textoEncontrado;
  } else {
    return capitalizeFirstLetter(id);
  }
}

export const obteneridFilterPorID = (id, categoryFilterId) => {
  let textoEncontrado;

  if (categoryFilterId) {
    textoEncontrado = categoryFilterId;
  }

  if (textoEncontrado) {
    return textoEncontrado;
  } else {
    return id;
  }
}

export const isServerEnvironment = () => {
  return typeof window === 'undefined';
};



export const typesProducts = ['FUSION_AV', 'FUSION_MV', 'FUSION_BV', 'FUSION_AV_ADDITIONAL', 'FUSION_MV_ADDITIONAL', 'FUSION_BV_ADDITIONAL', 'PARTICULARES'];
export const ImportantFilters = ['pageIndex', 'pageSize'];